/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { collectionStatsSchema } from '../getDashboard/collection-stats-schema';
import { getDashboardResponseDataSchema } from '../getDashboard/get-dashboard-response';

export const adminCollectionStatsSchema = collectionStatsSchema.extend({
  totalChallenges: z.number(),
  reviewedChallenges: z.number(),
});

export type IAdminCollectionStats = z.infer<typeof adminCollectionStatsSchema>;

export const getAdminUserProgressResponseDataSchema = getDashboardResponseDataSchema.extend({
  collections: z.array(adminCollectionStatsSchema),
});

export type IGetAdminUserProgressResponseData = z.infer<
  typeof getAdminUserProgressResponseDataSchema
>;

export const getAdminUserProgressResponseSchema = createApiResponseSchema(
  getAdminUserProgressResponseDataSchema,
) as z.ZodSchema<IAPI<IGetAdminUserProgressResponseData>>;

export type IGetAdminUserProgressResponse = IAPI<IGetAdminUserProgressResponseData>;
